import http from "./http";
const baseUrl = "/v2/api/system";
const baseUrl1 = "/v2/api/captcha";
const baseUrl2 = "/v2/api/document";

const { get, post } = http;
const getCodeSmsLogin = (params: any) => post(`${baseUrl}/message/code/common/sms/login`, params); // 登录的短信验证码
const systemLogin = (params: any) => post(`${baseUrl}/login`, params); // 账号密码登录
const smsLogin = (params: any) => post(`${baseUrl}/sms/login`, params); // 手机短信登录
const systemLogout = (params?: any) => post(`${baseUrl}/logout`, params); // 退出
const checkPhone = (params: any) => post(`${baseUrl}/user/check/phone`, params); // 校验手机号是否已存在
const checkUserName = (params: any) => post(`${baseUrl}/user/check/userName`, params); // 校验用户名是否已存在
const getCodeRegister = (params: any) => post(`${baseUrl}/message/code/common/sms/register`, params); // 注册的短信验证码
const getCodeForgot = (params: any) => post(`${baseUrl}/message/code/common/sms/reset/password`, params); // 忘记密码的短信验证码
const getCodeUpdatePwd = (params: any) => post(`${baseUrl}/message/code/user/sms/update/password`, params); // 修改密码的短信验证码
const getCodeCancel = (params: any) => post(`${baseUrl}/message/code/user/sms/cancel`, params); // 注销的短信验证码
const getCodeUpdatePhone = (params: any) => post(`${baseUrl}/message/code/user/sms/update/phone`, params); // 修改手机号旧号码的短信验证码
const getCodeUpdateNewPhone = (params: any) => post(`${baseUrl}/message/code/user/sms/update/newPhone`, params); // 修改手机号新号码的短信验证码
const getCodeUpdateUserName = (params: any) => post(`${baseUrl}/message/code/user/sms/update/userName`, params); // 修改用户名的短信验证码
const verifyCodeUpdateUserName = (params: any) => post(`${baseUrl}/message/code/user/token/update/userName`, params); // 修改用户名第一步验证
const verifyCodeUpdatePhone = (params: any) => post(`${baseUrl}/message/code/user/token/update/newPhone`, params); // 修改手机号第一步验证
const verifyCodeUpdatePwd = (params: any) => post(`${baseUrl}/message/code/user/token/update/password`, params); // 修改密码第一步验证
const verifyCodeCancel = (params: any) => post(`${baseUrl}/message/code/user/token/cancel`, params); // 注销账号第一步验证
const userCancel = (params?: any) => post(`${baseUrl}/user/cancel`, params); // 注销用户
const userRegister = (params?: any) => post(`${baseUrl}/user/register`, params); // 注册用户
const userResetPassword = (params?: any) => post(`${baseUrl}/user/reset/password`, params); // 忘记密码
const userUpdateName = (params?: any) => post(`${baseUrl}/user/update/userName`, params); // 修改用户名
const userUpdatePhone = (params?: any) => post(`${baseUrl}/user/update/phone`, params); // 修改手机号
const userUpdatePwd = (params?: any) => post(`${baseUrl}/user/update/password`, params); // 修改密码
const userDelete = (params?: any) => post(`${baseUrl}/user/delete/${params.userIds}`); // 删除用户
const getUserDetail = (params?: any) => get(`${baseUrl}/user/detail`, { params }); // 查询当前用户详情
const checkNewPhone = (params?: any) => post(`${baseUrl}/message/code/user/sms/check/newPhone`, params); // 修改手机号第二步获取验证码前检查新手机号
const getVerifyPicture = (params?: any) => post(`${baseUrl1}/sliderPuzzle/get`, params);
const verifyCheck = (params?: any) => post(`${baseUrl1}/sliderPuzzle/check`, params);
const documentQuery = (params: any) => post(`${baseUrl2}/document/query`, params);
// const getSuperAuthToken = (headers: any) => post(`/v1/api/app/super/auth/getToken`, {}, {headers}); // 获取超级设备管理平台的token

export default {
  getCodeSmsLogin,
  systemLogin,
  smsLogin,
  systemLogout,
  checkPhone,
  checkUserName,
  getCodeRegister,
  getCodeForgot,
  getCodeUpdatePwd,
  getCodeCancel,
  userCancel,
  userRegister,
  userResetPassword,
  getCodeUpdatePhone,
  getCodeUpdateNewPhone,
  getCodeUpdateUserName,
  verifyCodeUpdateUserName,
  verifyCodeUpdatePhone,
  verifyCodeUpdatePwd,
  verifyCodeCancel,
  userUpdateName,
  userUpdatePhone,
  userUpdatePwd,
  userDelete,
  getUserDetail,
  checkNewPhone,
  getVerifyPicture,
  verifyCheck,
  documentQuery,
  // getSuperAuthToken
};
